module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-form"
  }, [_c('form', {
    ref: "form",
    staticClass: "form",
    class: {
      'border': _vm.withBorder, 'form--box': _vm.withPadding
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('h2', {
    staticClass: "form__title"
  }, [_vm._v("ข้อมูลที่อยู่")]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("ที่อยู่")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.address),
      expression: "info.address"
    }],
    staticClass: "form__input",
    attrs: {
      "rows": "3",
      "name": "address",
      "id": "address"
    },
    domProps: {
      "value": (_vm.info.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "province"
    }
  }, [_vm._v("จังหวัด")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.province),
      expression: "info.province"
    }],
    staticClass: "form__input",
    attrs: {
      "name": "province",
      "id": "province"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.info, "province", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$utils.getProvinces()), function(pItem) {
    return _c('option', {
      key: pItem.code,
      domProps: {
        "value": pItem.code
      }
    }, [_vm._v(_vm._s(pItem.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "zipcode"
    }
  }, [_vm._v("รหัสไปรษณีย์")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.info.postalCode),
      expression: "info.postalCode"
    }],
    staticClass: "form__input",
    attrs: {
      "type": "text",
      "name": "zipcode",
      "id": "zipcode",
      "pattern": "[0-9]{5}",
      "max-length": "5"
    },
    domProps: {
      "value": (_vm.info.postalCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.info, "postalCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.showButton) ? _c('button', {
    staticClass: "btn btn--purple btn--full mt-15",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("บันทึก")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5beaf8df", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5beaf8df","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressForm.vue
// module id = 745
// module chunks = 1